export const emptyState = {
  betaHeadline: 'card-empty-beta-headline',
  betaSubheading: 'card-empty-beta-subheading',
  headline: 'card-empty-headline',
  image: 'card-empty-image',
  main: 'card-empty-state',
  subheading: 'card-empty-subheading',
};
